import React from 'react'
import { checkTextTranslation, checkTranslation, getObject } from '../../utils/useful'

class TableSelectInput extends React.Component {
    state = {
    }




    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    getLabel(key) {
        let header = this.props.header
        if (this.props.data) {
            if (header.showKey) {
                return getObject(this.props.fullValues, header.showKey)

            } else {
                if (typeof this.props.data == 'object') {

                    return getObject(this.props.data, this.props.header?.information?.fields?.title)
                } else {
                    if (this.props.header?.information?.items?.length) {
                        for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
                            const item = this.props.header?.information?.items[i];
                            if (item.value == this.props.data) {
                                return item[key]
                            }
                        }
                    }
                }
            }
        } else {
            if (this.props.header?.information?.default) {
                for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
                    const item = this.props.header?.information?.items[i];
                    if (item.value == this.props.header?.information?.default) {
                        return item[key]
                    }
                }
            } else {
                return ' '
            }
        }

    }

    render() {
        return (
            // <div className="w-100 h-100 flexcc">
            <div className={`w-100 h-100  ${this.props.onTable ? "" : 'flexc'}`}>

                <p className="" style={{ color: this.getLabel("color") ? this.getLabel("color") : '', backgroundColor: this.getLabel("background"), textOverflow: 'ellipsis', overflow: 'hidden', padding: this.props.onTable ? '' : '6px 14px', borderRadius: 30 }}>{checkTranslation(this.getLabel("title"))}</p>
            </div>
        )
    }
}

export default TableSelectInput;